import React, { PureComponent, Suspense } from "react";
import "./assets/css/analytics.scss";
import { connect } from "react-redux";
import { getAnalytcialStatus, updateFlags, } from "../../../../actions/analyticsAction";
import { togglePlanSection_D } from "../../../../actions/showDisplayModalAction";
import { Container } from "react-bootstrap";
import ErrorMessage from "./layout/common/errorMessage";

const ActivityhubDisplay = React.lazy(() => import("./activityHub/display"));
const ActivityhubWidget = React.lazy(() => import("./activityHub/widget"));
const Content = React.lazy(() => import("./content"));
const Subheader = React.lazy(() => import("./layout/common/subheader/subHeader"));
class Analytics extends PureComponent {

  state = { getanalyticsStatus: false }

  callback = () => { this.setState({ getanalyticsStatus: true }) }
  componentDidMount() {
    const { analyticsRecords, updateFlags, getAnalytcialStatus } = this.props;

    if (!analyticsRecords.getFlags.length) updateFlags();
    getAnalytcialStatus(localStorage.getItem("wallId"), this.callback());
  }

  render() {
    const { analyticsRecords, analyticsStatus, togglePlanSection, analyticwall } = this.props;

    return (<>
      <div>
        <Suspense fallback={<></>}> <Subheader /> </Suspense>
        <div id="sw_analytics_main" className="d-flex flex-column-fluid position-relative sw_analytics_main p-3" >
          <Container fluid>
            <ErrorMessage analyticsRecords={analyticsRecords} analyticsStatus={analyticsStatus} postCount={analyticwall?.selectedWallFeed?.postCount} togglePlanSection={togglePlanSection} />
            {analyticsRecords.activeTab == 1 ? <Suspense fallback={<></>}> <Content key={analyticsRecords.analytics_status_loader} /> </Suspense> : null}
            {analyticsRecords.activeTab == 2 ? <Suspense fallback={<></>}> <ActivityhubWidget />  </Suspense> : null}
            {analyticsRecords.activeTab == 3 ? <Suspense fallback={<></>}> <ActivityhubDisplay />  </Suspense> : null}
          </Container>
        </div>
      </div>
    </>
    );
  }
}

const contentStateToProps = (state) => {
  return {
    analyticsRecords: state.analyticsRecords,
    detail: state.appsMore.detail,
    analyticwall: state.analyticwall,
    analyticsStatus: state.analyticsStatus.trialAccessAPI,
  };
};

const contentDispatchToProps = (dispatch) => {
  return {
    updateFlags: () => dispatch(updateFlags()),
    getAnalytcialStatus: (wallId, callback) => dispatch(getAnalytcialStatus(wallId, callback)),
    togglePlanSection: () => dispatch(togglePlanSection_D(true)),
  };
};

export default connect(contentStateToProps, contentDispatchToProps)(Analytics);
